// Body of the Oscar thank-you (order confirmation) view: the legacy sealy
// layout -- the "Rest easy" intro, the order-number/help content title, the
// shared RichOrderDetail block (the collapsible order-summary-details panel +
// grouped lines with named-status progress bars, typed-serialized
// server-side), the display-only OrderOffer islands, and the e-signature /
// support footer. The order-details toggle is owned by the shared block's own
// disclosure state (collapsible).
import { Immutable } from "immer";
import React from "react";
import { RichOrderDetail } from "tsi-common-react/src/apps/customer-account/RichOrderDetail/index";

import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Template as OrderOffer } from "../../templates/OrderOfferTemplate";

import styles from "./index.module.scss";

type IProps = Immutable<templates.ThankYouDocumentTemplate>;

export const ThankYouPageBody = (props: IProps): React.JSX.Element => {
    return (
        <>
            <div
                className={concatClassNames([
                    styles.thankYouContainer,
                    "l-capped-width",
                    "u-margin-bottom--xl",
                    "u-full-width-title",
                ])}
            >
                <div
                    className={concatClassNames([styles.thankYou, "thank-you"])}
                >
                    <div className={styles.intro}>
                        <h3 className={styles.introTitle}>
                            Rest easy, <span>{props.first_name}.</span>{" "}
                            We&apos;re working on your order.
                        </h3>
                        <p className={styles.introCopy}>
                            You&apos;ll receive order confirmation emails at
                            each step of your order&apos;s progress, at{" "}
                            <strong>{props.email}</strong>. Check your order
                            status anytime at{" "}
                            <a
                                className={styles.introLink}
                                href={props.order_list_url}
                            >
                                Sealy.com
                            </a>
                            . Thanks for shopping with us.
                        </p>
                    </div>

                    {/* content-title stays literal: libs AccountContentTitle and
                        UtilityExpiredTokenBody render it too, and the global
                        content-title rules still apply here. */}
                    <div
                        className={concatClassNames([
                            "content-title",
                            styles.contentTitle,
                        ])}
                    >
                        <h4 className="content-title__headline">
                            ORDER NUMBER: {props.order_number} |{" "}
                            {props.order_date}
                        </h4>
                        <span className="content-title__info">
                            Need Help?{" "}
                            <a href={props.cs_phone_rfc3966}>
                                {props.cs_phone_national}
                            </a>
                        </span>
                    </div>
                </div>

                {/* rich_order_detail is the sealy shape; the shared template
                    types it nullable (the other sites' shapes live in sibling
                    props), but on sealy it is always populated. */}
                {props.rich_order_detail && (
                    <RichOrderDetail
                        {...props.rich_order_detail}
                        collapsible={true}
                    />
                )}
                {props.offers.map((offer, i) => (
                    <div
                        key={i}
                        className="thank-you-order-offer l-capped-width"
                    >
                        <OrderOffer {...offer} />
                    </div>
                ))}
            </div>
            <div className={styles.thankYouEsig}>
                {props.has_esignature && (
                    <div className={styles.thankYouEsigCopy}>
                        <span className={styles.thankYouEsigCopyBold}>
                            Electronic Signature:
                        </span>{" "}
                        Acknowledged &amp; Signed on {props.esig_signed_date}{" "}
                        {props.esig_signed_time}
                    </div>
                )}
                <div className={styles.thankYouEsigCopy}>
                    Questions or concerns? Talk to a Sleep Expert at{" "}
                    <a
                        className={styles.thankYouEsigCopyBold}
                        href={props.cs_phone_rfc3966}
                    >
                        {props.cs_phone_national}
                    </a>
                    .
                </div>
            </div>
        </>
    );
};
